var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5865F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0105 9.82974C13.0106 9.24153 11.75 9.96251 11.75 11.1226V20.8774C11.75 22.0375 13.0106 22.7585 14.0105 22.1703L22.3021 17.2929C23.288 16.7129 23.288 15.2871 22.3021 14.7071L14.0105 9.82974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPauseIcon);
export default __webpack_public_path__ + "static/media/player_pause_icon.fc7b000020de6834482bbfae7a31a1cc.svg";
export { ForwardRef as ReactComponent };